import { IconExternalLink } from "./icons";

const models = [
  ["Claude Opus", "Claude Sonnet", "GPT", "Nova"],
  ["Llama", "Qwen"],
];

const Pill = ({ label }: { label: string }) => (
  <span className="inline-flex items-center px-[9px] py-[4px] rounded-full border border-[#cdbdff] bg-[#efeaff] text-[12px] leading-[16.5px] text-[#270294] whitespace-nowrap">
    {label}
  </span>
);

export const ProvidersBadge = () => {
  return (
    <div className="flex flex-col gap-2">
      <p className="text-[10px] font-semibold uppercase tracking-[0.5px] text-black-500">
        Seamlessly switch models
      </p>
      <div className="flex flex-col gap-2">
        {models.map((row, i) => (
          <div key={i} className="flex items-center gap-2 flex-wrap">
            {row.map((name) => (
              <Pill key={name} label={name} />
            ))}
            {i === models.length - 1 && (
              <a
                href="https://www.aptible.com/docs/supported-models"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-[2px] text-[12px] leading-[16.5px] text-indigo-500 whitespace-nowrap"
              >
                View all supported models
                <IconExternalLink variant="sm" />
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
